import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 2,
		width: 18,
		height: 14,
		rx: 3,
		stroke: "#999999",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.5 2.5L10 9L18.5 2.5",
		stroke: "#999999",
		strokeWidth: 2
	})]
});
export default SvgEmail;
